import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { Creators as SessionsCreators } from '../../store/ducks/session';

class AuthToken extends PureComponent {
  componentWillMount = () => {
    this.props.authByToken(this.props.match.params.token);
  };
  render = () => <Fragment />;
}

const mapDispatchToProps = dispatch => bindActionCreators(SessionsCreators, dispatch);

export default withRouter(connect(
  null,
  mapDispatchToProps,
)(AuthToken));



// WEBPACK FOOTER //
// ./src/pages/authToken/index.js